export default {
	OAUTH_URL:'/wxapi/oauth/openid?r=STUDENT',
	JSSDK_URL:'/wxapi/jssdk'
}



// WEBPACK FOOTER //
// ./src/config/params.js